const dialogCls = "c2ldte0itj";
const headingCls = "c2lhfq5pat";
const inputWrapperCls = "c2li15sokf";
const selectWrapperCls = "c2lsv7p6va";
const buttonContainerCls = "c2lb1a2ghk3";
const errorEntryCls = "c2le173whu8";

/** Ensure select dropdown positions itself over the settings lightbox */
const selectDropdownCls = "c2ls14zaqo7";

export { buttonContainerCls, dialogCls, errorEntryCls, headingCls, inputWrapperCls, selectDropdownCls, selectWrapperCls };
import "./settings-lightbox.style.linaria.module.css";
//# sourceMappingURL=settings-lightbox.style.js.map
